(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/terms-integrity/assets/javascripts/models/cookies.js') >= 0) return;  svs.modules.push('/modules/terms-integrity/assets/javascripts/models/cookies.js'); 
(function(Backbone, svs) {
  'use strict';

  svs.terms_integrity.models.Cookies = svs.terms_integrity.models.Base.extend({
    initialize: function() {
      if (svs.terms_integrity.data && svs.terms_integrity.data.cookies) {
        this.set({
          cookies: svs.terms_integrity.data.cookies || {}
        });
      } else {
        this.getDocumentsFromCMS('cookies');
      }
      this.getFaqFromCMS('faqCookies');

    }
  });
})(Backbone, svs);

 })(window);